import { useEffect, useState } from "react";
import { formatRelativeDate } from "../../utils/date";
import { useTranslation } from "react-i18next";

export function TimeAgo({
	date,
	simple = false,
	showText = false,
	onlyValue = false,
}) {
	const { t, i18n } = useTranslation();
	const [elapsedTime, setElapsedTime] = useState("0s");
	const [isFuture, setIsFuture] = useState(false);

	useEffect(() => {
		const updateTime = () => {
			const diff = Date.now() - new Date(date).getTime();

			setIsFuture(diff < 0);

			setElapsedTime(
				formatRelativeDate(date, Date.now(), {
					simple,
					minDays: false,
					onlyValue,
					language: i18n.language,
				})
			);

			return diff;
		};

		const diff = updateTime();

		let intervalMs = 1000;

		if (Math.abs(diff) >= 1000 * 60 * 60) {
			intervalMs = 1000 * 60 * 60;
		} else if (Math.abs(diff) >= 1000 * 60) {
			intervalMs = 1000 * 60;
		}

		const interval = setInterval(updateTime, intervalMs);

		return () => clearInterval(interval);
	}, [date, simple, onlyValue, i18n.language]);

	const isEnglish = i18n.language === "en";

	return (
		<>
			{showText && elapsedTime !== "Agora" && (
				<>
					{isEnglish ? (
						` ${t("common.ago").toLowerCase()}`
					) : (
						`${isFuture ? "em" : "há"} `
					)}
				</>
			)}

			{elapsedTime}
		</>
	);
}
